import { useVideo } from "../../hooks/useVideo";
import "./plansProducts.scss";
import { useGetWooProductsByIdsQuery } from "../../features/api/wooApiSlice";
import LoadingSpinner from "../loader/Loader";

const PlansAndProducts = () => {
  const { selectedVideo } = useVideo();
  // const { data: wooProducts, isLoading } = useGetWooProductsQuery({});

  const { data: linkedProducts = [], isLoading } = useGetWooProductsByIdsQuery(
    selectedVideo?.products?.join(","),
    { skip: !selectedVideo?.products }
  );

  if (isLoading) return <LoadingSpinner />;
  return (
    <>
      {selectedVideo?.products?.length ? (
        <div className="main-area-right">
          <div className="selected-video-plans-products">
            <div className="plans-products-header">
              <h3>Plans and Products</h3>
            </div>
            <div className="plans-products-body">
              {selectedVideo?.products?.map((productId, index) => {
                const product = linkedProducts?.find(
                  (p) => p?.id.toString() === productId
                );

                if (!product) return null;

                const isOutOfStock = product.stock_status === "outofstock";

                // **NEW LOGIC: More robust price HTML cleaning**
                let cleanedPriceHtml = product?.price_html;

                // **NEW LOGIC: Remove the screen-reader-text span**
                if (cleanedPriceHtml) {
                  cleanedPriceHtml = cleanedPriceHtml.replace(
                    /<span class="screen-reader-text">.*?<\/span>/g,
                    ""
                  );
                }

                return (
                  <div
                    key={product?.id || `missing-${index}`}
                    className="product-card"
                  >
                    <div className="product-image-container">
                      <img
                        className="table-image"
                        src={product?.images?.[0]?.src}
                        alt={product?.name}
                      />
                      {/* Add the stock badge */}
                      <span
                        className={`stock-badge ${
                          isOutOfStock ? "out-of-stock" : "in-stock"
                        }`}
                      >
                        {isOutOfStock ? "Out of Stock" : "In Stock"}
                      </span>
                    </div>
                    <div className="product-card-details">
                      <h4>{product?.name}</h4>
                      {/* Use the cleaned price HTML */}
                      <p
                        dangerouslySetInnerHTML={{ __html: cleanedPriceHtml }}
                      />
                      <a
                        className="buy-now_link"
                        href={product?.permalink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Product
                      </a>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default PlansAndProducts;
